import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import qs from 'qs';
import { getServerLogger } from '$util/index';
import { queryCmsContent } from '$server/modules/cms';
import BannerWithCta from '$components/Widgets/BannerWithCta';
import WidgetEditor from '$components/Widgets/WidgetEditor';
import StartBooking from '$components/Widgets/StartBooking';
import Trustpilot from '$components/Widgets/Trustpilot';
import UspBanner from '$components/Widgets/UspBanner';
import BlogReminder from '$components/Widgets/BlogReminder';
import { getNavbarQuery } from '$commons/gql';
import { getVrmLookupQuery } from '$quantum/molecules/VrmLookup/gql';

const PAGE_NAME = 'widgets';

function WidgetPage({ ...props }) {
  const { data } = props.pageType[0];
  const { template } = data;
  const path = useRouter().asPath;
  const params = Object.fromEntries(new URLSearchParams(path.split('?')[1]));

  switch (template) {
    case 'widget-editor':
      return <WidgetEditor />;
    case 'banner-with-cta':
      return <BannerWithCta data={data} params={params} />;
    case 'start-booking':
      return <StartBooking />;
    case 'trustpilot-widget':
      return <Trustpilot data={data} params={params} />;
    case 'usp-banner':
      return <UspBanner data={data} params={params} />;
    case 'reminder-blog':
      return <BlogReminder data={data} params={params} />;

    default:
      return null;
  }
}

export const getServerSideProps = async ({ locale, query }) => {
  const log = getServerLogger(PAGE_NAME);
  const { pathname, pageType, pageMeta, pageTypeFromPath } = qs.parse(query);
  log.debug({ pageType, pageTypeFromPath }, 'getServerSideProps for page %s', PAGE_NAME);

  const cmsContent = await queryCmsContent(PAGE_NAME, {
    cmsQuery: [getNavbarQuery, getVrmLookupQuery],
    context: {
      variables: {
        locale,
      },
    },
  });

  return {
    props: {
      cmsContent,
      pathname,
      pageType,
      pageMeta,
      pageTypeFromPath,
    },
  };
};

WidgetPage.propTypes = {
  pathname: PropTypes.string.isRequired,
  pageType: PropTypes.array.isRequired,
  pageMeta: PropTypes.object.isRequired,
};

export default WidgetPage;
